import * as React from "react";
import "@aurodesignsystem/auro-button";
import "@alaskaairux/auro-icon";
import "./Titlebar.scss";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

interface TitleBarClosedProps {
  otsAircraftCount: number;
  editClicked?: any;
  reopenClicked?: any;
}

export default function TitleBarClosed(props: TitleBarClosedProps) {
  const location = useLocation();
  const aircraftData = useSelector((state) => state.otsAircraft.otsAircraft);
  const [showEditButton, setShowEditButton] = React.useState(false);
  const [labelText, setLabelText] = React.useState("Closed events");
  const [previousLabelText, setPreviousLabelText] =
    React.useState("Closed events" + " ");
    const ArrowIcon = () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 1 18 17" fill="none">
                              <path fillRule="evenodd" clipRule="evenodd" d="M7.26694 12.4687L7.20736 12.4173C7.01875 12.2287 7.00161 11.9335 7.15592 11.7256L7.20736 11.666L10.3731 8.49996L7.20736 5.33394C7.01875 5.14534 7.00161 4.8502 7.15592 4.64223L7.20736 4.58264C7.39596 4.39404 7.6911 4.37689 7.89907 4.5312L7.95866 4.58264L11.1247 7.74842L11.1691 7.79285C11.5596 8.18338 11.5596 8.81654 11.1691 9.20707L11.1247 9.2515L7.95866 12.4173C7.77005 12.6059 7.47492 12.623 7.26694 12.4687L7.20736 12.4173L7.26694 12.4687Z" fill="#0074cb" />
                          </svg>);
                          const getArrowIcon = () => <ArrowIcon />;
  const setTitlebarText = () => {
    if (location.pathname.indexOf("/edit-ots") > -1) {
      setLabelText("Closed event details");
      setShowEditButton(false);
      setPreviousLabelText("Closed events");
    } else if (location.pathname.indexOf("/event-details") > -1) {
      setLabelText("Closed event details");
      if(aircraftData.IsConversationArchived){
        setShowEditButton(false);
      }else{
        setShowEditButton(true);
      }
    } else {
        if (props.otsAircraftCount) {
      setLabelText(`Closed events (${props.otsAircraftCount})`);
        } else {
            setLabelText(`Closed events`);
         } 
       setShowEditButton(false);
    }
  };

  React.useEffect(() => {
      setTitlebarText();
  }, [location.pathname, props.otsAircraftCount]);
  return (
    <div className="titlebar">
      {labelText == "Closed event details" ? (
        <a href={"/closed-events"} className="lblcreatesize-breadcrumbs">
          {previousLabelText}
          <React.Fragment>{getArrowIcon()}</React.Fragment>
        </a>
      ) : (
        ""
      )}
      <label className={`lblotsevent lblunscheduledsize`}> {labelText}</label>
      {showEditButton && (
        <div className="fullWidth">
          <auro-button
            variant="primary"
            fluid="true"
            onClick={() => props.editClicked(true)}
          >
            <span className="btnlabel-white">Edit</span>
          </auro-button>
        </div>
      )}
    </div>
  );
}
